import React from 'react'
import { Form, FormGroup, FormControl, Button, Table } from 'react-bootstrap'
import PropTypes from 'prop-types'
import { client } from '../../utils'

export default class App extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      currentRoyalties: this.props.royalties.currentRoyalties,
      availableAuthors: this.props.royalties.availableAuthors,
      newAuthor: '',
      newAuthorRate: 0.0,
    }
    this.handleRateChange = this.handleRateChange.bind(this)
    this.handleAuthorChange = this.handleAuthorChange.bind(this)
    this.addAuthor = this.addAuthor.bind(this)
    this.removeAuthor = this.removeAuthor.bind(this)
  }

  async removeAuthor(accountID) {
    let coursenum = this.props.coursenum
    let url = `/instructor/admin_setup.remove_stripe_connect_author/${coursenum}/${accountID}/`
    let response = await client.post(url)
    this.setState({
      currentRoyalties: response.data.currentRoyalties,
    })
  }

  async addAuthor(e) {
    e.preventDefault()
    let coursenum = this.props.coursenum
    let rate = this.state.newAuthorRate * 100
    let url = `/instructor/admin_setup.add_stripe_connect_author/${coursenum}/${this.state.newAuthor}/${rate}/`
    let response = await client.post(url)
    this.setState({
      newAuthor: '',
      newAuthorRate: 0.0,
      currentRoyalties: response.data.currentRoyalties,
    })
  }

  handleRateChange(e) {
    this.setState({
      newAuthorRate: e.target.value,
    })
  }

  handleAuthorChange(e) {
    this.setState({
      newAuthor: e.target.value,
    })
  }

  render() {
    return (
      <div>
        <h3>Stripe Connect Royalties</h3>
        <Table striped bordered condensed hover>
          <thead>
            <tr>
              <th>Author</th>
              <th>Rate</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {this.state.currentRoyalties.map((x, key) => (
              <tr key={`r${key}`}>
                <td>{x.name}</td>
                <td>{(x.rate * 100).toFixed(2)}%</td>
                <td>
                  <Button
                    bsStyle="danger"
                    className="btn-myed btn-danger-myed btn-sm-myed"
                    onClick={() => this.removeAuthor(x.account_id)}
                  >
                    <i className="far fa-times fa-fw mr-2" /> Remove
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        {this.state.currentRoyalties.map((royalty, i) => {
          if (!royalty.account_id) {
            return (
              <p key={i} className="text-danger">
                {royalty.name} has no Stripe Account ID
              </p>
            )
          }
        })}
        <h3>Add New Author</h3>
        <Form inline>
          <FormGroup controlId="formControlsSelect" className="mr-2">
            <FormControl
              componentClass="select"
              placeholder="select"
              onChange={this.handleAuthorChange}
            >
              <option value="">Select Author</option>
              {this.state.availableAuthors.map((x, key) => (
                <option key={key} value={x.accountID}>
                  {x.name}
                </option>
              ))}
            </FormControl>
          </FormGroup>
          <FormGroup className="mr-2">
            <label htmlFor="rate" className="hidden_label">
              Rate
            </label>
            <FormControl
              id="rate"
              type="text"
              placeholder="Rate (as decimal)"
              onChange={this.handleRateChange}
            />
          </FormGroup>
          <Button
            type="submit"
            bsStyle="success"
            className="btn-myed btn-success-myed"
            disabled={!this.state.newAuthor || !this.state.newAuthorRate}
            onClick={this.addAuthor}
          >
            <i className="far fa-plus" /> Add
          </Button>
        </Form>
      </div>
    )
  }
}

App.propTypes = {
  coursenum: PropTypes.string,
  royalties: PropTypes.object,
}
